import {
    LOCATION_CHANGE,
    LOGOUT,
    SIDEBAR_OPEN,
    SIDEBAR_CLOSE,
    SIDEBAR_LOCK
} from 'constants/actionTypes';

const sidebarDefaultState = {
    opened: false
};

export const sidebarReducer = (state = sidebarDefaultState, action) => {
    switch(action.type) {
        case SIDEBAR_OPEN:
            return {
                ...state,
                opened: true,
                id: action.payload.id,
                params: action.payload.params || {},
                componentName: action.payload.componentName
            };
        case SIDEBAR_LOCK:
            return {
                ...state,
                locked: !state.locked
            };
        case LOCATION_CHANGE:
            return state.locked ? state : sidebarDefaultState;
        case LOGOUT:
        case SIDEBAR_CLOSE:
            return sidebarDefaultState;
        default:
            return state;
    }
};
